import React, {useRef} from "react";
import { Modal } from "react-bootstrap";

export default function ContactForm(props) {
  const formRef = useRef();
  return (<>
    <Modal show={props.show} onHide={props.handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{"Get in Touch"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="contact-form px-2 py-1">
          <div>
            <iframe
              ref={formRef}
              onLoad={(e) => {
                try {
                  if (formRef.current.contentWindow.location.href.indexOf("?") > -1) {
                    props.handleClose();
                  }
                } catch (ee) {
                  console.log("err", e);
                }
              }}
              style={{ border: 0, width: "100%", minHeight: 630 }}
              src="/contact-form/" />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  </>)
}
